import { scroll } from "motion";

export default () => ({
  cancel: null,
  init() {
    this.cancel = scroll(
      (progress) => {
        if (progress > 0 && progress < 1) {
          window.Alpine.store("sticky").showNav();
        } else {
          window.Alpine.store("sticky").hideNav();
        }
      },
      {
        target: this.$root,
        offset: ["start start", "end end"],
      },
    );
  },
  destroy() {
    if (this.cancel) {
      this.cancel();
    }
  },
});
